<template>
  <div class="container-fluid py-3 px-4">

    <div class="border border-1 rounded-3 p-3 mb-2 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-pc-display display-4 text-primary" style="transform: scaleX(1.2);"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            DISPOSITIVOS
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            LISTADO DE DISPOSITIVOS TECNOLOGICOS
          </p>
        </div>
      </div>
    </div>


    <div class="row align-items-center mb-1 mx-0">
      <!-- Botones -->

      <div class="border border-1 rounded-3 p-3 mb-2">
        <div class="col-12 col-md-6 d-flex flex-wrap gap-2 mb-4 mb-md-0">
          <button class="btn btn-warning boton-estiloCuadrado" @click="abrirModal('agregar')">
            <i class="bi bi-plus"></i>
          </button>

          <button class="btn btn-danger boton-estiloCuadrado" :disabled="selectedRows.length === 0"
            @click="eliminarSeleccionados">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>

      <!-- Tabla de dispositivos -->
      <div class="border border-1 rounded-3 p-3 mb-2">
        <!-- Buscador -->
        <div class="row mb-3 justify-content-end mt-3">
          <div class="d-flex justify-content-end mt-2">
            <span for="" class="input-group-text mt-2 buscar-estiloCuadrado"> <i class="bi bi-search"></i></span>
            <input class="form-control form-control-lg w-25 mt-2 me-2 buscar-estiloCuadrado" type="text"
              aria-label=".form-control-lg example" placeholder="ID /SERIE /MARCA /MODELO" v-model="busqueda"
              @input="busqueda = busqueda.replace(/\s+/g, ''); filtro()" @keydown.space.prevent />
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-bordered">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th><i class="bi bi-boxes"></i></th>
                <th @click="ordenar('idDispositivo')" class="cursor-pointer">
                  ID
                  <i v-if="sortKey === 'idDispositivo'"
                    :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                </th>

                <th @click="ordenar('desDisEstado')" class="cursor-pointer">
                  ESTADO
                  <i v-if="sortKey === 'desDisEstado'"
                    :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                </th>

                <th @click="ordenar('desModalidad')" class="cursor-pointer">
                  MODALIDAD
                  <i v-if="sortKey === 'desModalidad'"
                    :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                </th>

                <th @click="ordenar('empresa')" class="cursor-pointer">
                  EMPRESA
                  <i v-if="sortKey === 'empresa'"
                    :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                </th>

                <th @click="ordenar('desTipEstado')" class="cursor-pointer">
                  DISPOSITIVO
                  <i v-if="sortKey === 'desTipEstado'"
                    :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                </th>

                <th>
                  DESCRIPCION

                </th>

                <th>
                  COMENTARIO

                </th>

                <th @click="ordenar('disMontoSinIgv')" class="cursor-pointer">
                  MONTO SIN IGV
                  <i v-if="sortKey === 'disMontoSinIgv'"
                    :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                </th>

                <th @click="ordenar('disFecCompra')" class="cursor-pointer">
                  FEC. COMPRA
                  <i v-if="sortKey === 'disFecCompra'"
                    :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                </th>

                <th @click="ordenar('disGuia')" class="cursor-pointer">
                  GUIA
                  <i v-if="sortKey === 'disGuia'"
                    :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                </th>

                <th @click="ordenar('disFactura')" class="cursor-pointer">
                  FACTURA
                  <i v-if="sortKey === 'disFactura'"
                    :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                </th>

              </tr>
            </thead>
            <tbody>
              <!-- FILTRANDO INFORMACIÓN -->
              <tr v-if="loading">
                <td colspan="12" class="text-center align-middle" style="height: 200px;">
                  <div class="d-flex flex-column align-items-center justify-content-center h-100">
                    <div class="spinner-border text-primary" role="status" style="width: 6rem; height: 6rem;"></div>
                    <div class="mt-3 text-primary fw-semibold fs-5">
                      <i class="bi bi-funnel-fill me-2"></i> Filtrando información...
                    </div>
                  </div>
                </td>
              </tr>

              <!-- TABLA DE DISPOSITIVOS -->
              <tr v-else v-for="dispositivo in dispositivosPaginados" :key="dispositivo.idDispositivo"
                class="text-center align-middle reducirTamaño text-nowrap"
                :class="{ 'table-danger': dispositivo.desDisEstado === 'BAJA (INOPERATIVO)' }">


                <!-- ACCIONES -->
                <td class="text-center">
                  <div class="d-flex justify-content-center gap-2">
                    <button class="btn btn-outline-success btn-sm boton-estiloCuadrado"
                      @click="abrirModal('editar', dispositivo)" title="Editar registro">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </td>

                <!-- ID -->
                <td><strong>{{ dispositivo.idDispositivo }}</strong></td>

                <!-- ESTADO -->
                <td :class="{
                  'text-success fw-bold': dispositivo.desDisEstado === 'ACTIVO',
                  'text-dark fw-bold': dispositivo.desDisEstado === 'INACTIVO (REPARACION)',
                  'text-warning fw-bold': dispositivo.desDisEstado === 'BAJA (VENTA)',
                  'text-danger fw-bold': dispositivo.desDisEstado === 'BAJA (INOPERATIVO)',
                  'text-primary fw-bold': dispositivo.desDisEstado === 'LIBRE'
                }">
                  <i class="bi" :class="{
                    'bi-check-circle-fill text-success': dispositivo.desDisEstado === 'ACTIVO',
                    'bi-tools text-dark': dispositivo.desDisEstado === 'INACTIVO (REPARACION)',
                    'bi-cash-coin text-warning': dispositivo.desDisEstado === 'BAJA (VENTA)',
                    'bi-x-circle-fill text-danger': dispositivo.desDisEstado === 'BAJA (INOPERATIVO)',
                    'bi-laptop text-primary': dispositivo.desDisEstado === 'LIBRE'
                  }"></i>
                  {{ dispositivo.desDisEstado }}
                </td>

                <!-- MODALIDAD / PROVEEDOR -->
                <td class="text-start">
                  <div>
                    <span :class="{
                      'text-primary fw-bold': dispositivo.desModalidad === 'ALQUILER',
                      'text-danger fw-bold': dispositivo.desModalidad === 'COMPRA'
                    }">
                      <i class="bi" :class="{
                        'bi-building': dispositivo.desModalidad === 'ALQUILER',
                        'bi-cart-fill': dispositivo.desModalidad === 'COMPRA'
                      }"></i>
                      {{ dispositivo.desModalidad }}
                    </span>
                  </div>
                  <small class="text-muted">
                    <i class="bi bi-person-vcard me-1"></i> {{ dispositivo.desProveedor }}
                  </small>
                </td>

                <!-- EMPRESA -->
                <td class="text-start">
                  <i class="bi bi-building-fill me-1 text-secondary"></i>
                  {{ dispositivo.empresa }}
                </td>

                <!-- TIPO -->
                <td class="text-start">

                  {{ dispositivo.desTipEstado }}
                </td>

                <!-- DETALLE TÉCNICO -->
                <td class="text-start">
                  <div class="fw-semibold text-dark">
                    <i class="bi bi-cpu-fill me-1"></i>
                    {{ dispositivo.disMarca }} - {{ dispositivo.disModelo }}
                  </div>
                  <small class="text-muted">
                    <i class="bi bi-memory me-1"></i>
                    {{ dispositivo.disProcesador }} | {{ dispositivo.disMemoria }} | {{ dispositivo.disDiscoDuro }}
                  </small>
                  <br />
                  <small class="text-muted">
                    <i class="bi bi-plug me-1"></i> {{ dispositivo.disCargador }}
                  </small>
                  <br />
                  <span class="text-dark fw-bold">
                    <i class="bi bi-upc-scan me-1 text-muted"></i> Serie: {{ dispositivo.disSerie }}
                  </span>
                </td>

                <!-- COMENTARIO -->
                <td class="text-start">
                  <small><i class="bi bi-chat-dots text-muted me-1"></i> {{ dispositivo.disComentario }}</small>
                </td>

                <!-- MONTO -->
                <td class="fw-bold text-success">
                  {{ 'S/. ' + dispositivo.disMontoSinIgv.toFixed(2) }}
                </td>

                <!-- FECHA COMPRA -->
                <td>
                  <i class="bi bi-calendar-check text-success me-1"></i>
                  {{ dispositivo.disFecCompra }}
                </td>

                <!-- GUÍA -->
                <td>
                  <i class="bi bi-truck text-secondary me-1"></i>
                  {{ dispositivo.disGuia }}
                </td>

                <!-- FACTURA -->
                <td>
                  <i class="bi bi-file-earmark-text text-info me-1"></i>
                  {{ dispositivo.disFactura }}
                </td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
      <!-- Paginación -->
      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
        <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>
        <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="pagination-info">Página {{ currentPage }} de {{ totalPages }}</span>
        <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-right"></i>
        </button>
        <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
          :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-double-right"></i>
        </button>
      </div>

    </div>


    <!-- Modal -->
    <div v-if="mostrarModal" class="modal-backdrop show" @click="cerrarModal"
      style="z-index: 1050; position: fixed; inset: 0; background-color: rgba(0, 0, 0, 0.5);"></div>

    <div v-if="mostrarModal" class="modal fade show d-block" tabindex="-1" role="dialog" style="z-index: 1055;">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document" @click.stop>
        <div class="modal-content">
          <!-- HEADER -->
          <div class="modal-header">
            <h5 class="modal-title text-center w-100 fw-bold text-uppercase">
              {{ modalModo === "agregar" ? "Agregar Dispositivo Tecnológico" : "Modificar Dispositivo Tecnológico" }}
            </h5>
            <button type="button" class="btn-close" @click="cerrarModal"></button>
          </div>

          <!-- BODY -->
          <div class="modal-body">
            <form @submit.prevent="guardarModal">

              <!-- FILA 1 -->
              <div class="row mb-3">
                <div class="col-md-4">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-building text-primary fs-5"></i>NOMBRE DE LA EMPRESA
                  </label>
                  <select required @change="EscogerEmpresa($event)" class="form-control text-secondary">
                    <option selected disabled>{{ editarDispo.empresa || '-- SELECCIONAR EMPRESA --' }}</option>
                    <option v-for="empresa in DniEmpre" :key="empresa.id" :value="empresa.id">
                      {{ empresa.empRazSocial }}
                    </option>
                  </select>
                </div>

                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-laptop text-success fs-5"></i>TIPO DISPOSITIVO
                  </label>
                  <select required @change="mandarTipDisp($event)" class="form-control text-secondary">
                    <option selected disabled>{{ editarDispo.desTipEstado || '-- DISPOSI --' }}</option>
                    <option v-for="estado in EstadoDis" :key="estado.id" :value="estado.parCorrelativo">
                      {{ estado.parDescripcion }}
                    </option>
                  </select>
                </div>

                <div class="col-md-3">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-truck text-warning fs-5"></i>PROVEDOOR
                  </label>
                  <select required @change="EscogerProvedores($event)" class="form-control text-secondary">
                    <option selected disabled>{{ editarDispo.desProveedor || '-- SELECCIONAR PROVEEDOR --' }}</option>
                    <option v-for="provedor in Proveedores" :key="provedor.id" :value="provedor.parCorrelativo">
                      {{ provedor.parDescripcion }}
                    </option>
                  </select>
                </div>

                <div class="col-md-3">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-activity text-danger fs-5"></i>ESTADO DISPOSITIVO
                  </label>
                  <select required :disabled="modalModo == 'agregar'" @change="mandarTipDispo($event)"
                    class="form-control text-secondary">
                    <option selected disabled>
                      {{ modalModo == 'agregar' ? (editarDispo.desDisEstado = 'LIBRE') : editarDispo.desDisEstado }}
                    </option>
                    <option v-for="estadodi in EstadoDispo" :key="estadodi.id" :value="estadodi.parCorrelativo">
                      {{ estadodi.parDescripcion }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- FILA 2 -->
              <div class="row mb-3">
                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-sliders text-info fs-5"></i>MODALIDAD
                  </label>
                  <select required @change="Modalidad($event)" class="form-control text-secondary">
                    <option selected disabled>{{ editarDispo.desModalidad || '-- SELECCIONAR MODALIDAD --' }}</option>
                    <option v-for="modalidad in ModalidadArreglo" :key="modalidad.id" :value="modalidad.parCorrelativo">
                      {{ modalidad.parDescripcion }}
                    </option>
                  </select>
                </div>

                <div class="col-md-3">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-receipt text-primary fs-5"></i>GUIA
                  </label>
                  <input v-model="disGuia" type="text" class="form-control" placeholder="-- GUIA --"
                     @input="disGuia = disGuia.replace(/^\s+/, '')"
                    @keydown.space="disGuia.length === 0 && $event.preventDefault()" />
                </div>

                <div class="col-md-3">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-file-earmark-text text-success fs-5"></i>FACTURA
                  </label>
                  <input v-model="disFactura" type="text" class="form-control" placeholder="-- FACTURA --"
                      @input="disFactura = disFactura.replace(/^\s+/, '')"
                    @keydown.space="disFactura.length === 0 && $event.preventDefault()" />
                </div>

                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-calendar-check text-success fs-5"></i>F.COMPRA
                  </label>
                  <input v-model="disFecCompra" required type="date" class="form-control" />
                </div>

                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-cash text-success fs-5"></i>MTO. SIN IGV
                  </label>
                  <input v-model="disMontoSinIgv" required type="number" step="0.01" class="form-control"
                    placeholder="-- MONTO --"  @input="disMontoSinIgv = disMontoSinIgv.replace(/^\s+/, '')"
                    @keydown.space="disMontoSinIgv.length === 0 && $event.preventDefault()" />
                </div>
              </div>

              <!-- FILA 3 -->
              <div class="row mb-3">
                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-cpu text-danger fs-5"></i>MARCA
                  </label>
                  <input v-model="disMarca" required :disabled="distipDispositivo === '003'" type="text"
                    class="form-control" placeholder="-- MARCA --"   @input="disMarca = disMarca.replace(/^\s+/, '')"
                    @keydown.space="disMarca.length === 0 && $event.preventDefault()" />

                </div>

                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-box text-info fs-5"></i>MODELO
                  </label>
                  <input v-model="disModelo" required :disabled="distipDispositivo === '003'" type="text"
                    class="form-control" placeholder="-- MODELO --"
                      @input="disModelo = disModelo.replace(/^\s+/, '')"
                    @keydown.space="disModelo.length === 0 && $event.preventDefault()" />
                </div>

                <div class="col-md-4">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-speedometer text-primary fs-5"></i>PROCESADOR
                  </label>
                  <input v-model="disProcesador" required :disabled="distipDispositivo === '003'" type="text"
                    class="form-control" placeholder="-- PROCESADOR --"
                     @input="disProcesador = disProcesador.replace(/^\s+/, '')"
                    @keydown.space="disProcesador.length === 0 && $event.preventDefault()" />
                </div>

                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-memory text-success fs-5"></i>MEMORIA
                  </label>
                  <input v-model="disMemoria" required :disabled="distipDispositivo === '003'" type="text"
                    class="form-control" placeholder="-- MEMORIA --"
                      @input="disMemoria = disMemoria.replace(/^\s+/, '')"
                    @keydown.space="disMemoria.length === 0 && $event.preventDefault()" />
                </div>

                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-hdd text-secondary fs-5"></i>DISCO DURO
                  </label>
                  <input v-model="disDiscoDuro" required :disabled="distipDispositivo === '003'" type="text"
                    class="form-control" placeholder="-- DISCO DURO --"
                      @input="disDiscoDuro = disDiscoDuro.replace(/^\s+/, '')"
                    @keydown.space="disDiscoDuro.length === 0 && $event.preventDefault()"/>
                </div>
              </div>

              <!-- FILA 4 -->
              <div class="row mb-3">
                <div class="col-md-2">
                                
                  <label  class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-upc-scan text-warning fs-5"></i>SERIE
                  </label>

                  <input v-model="disSerie" required type="text" class="form-control" placeholder="-- SERIE --"
                      @input="disSerie = disSerie.replace(/^\s+/, '') , validarSim()"
                    @keydown.space="disSerie.length === 0 && $event.preventDefault()"/>

                     <label v-if="validarSimCard" class="form-label text-danger  fw-semibold">
                    <i class="bi bi-exclamation-circle fs-6"></i>Serie ya existente
                  </label> 
                </div>

                <div class="col-md-4">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-plug text-danger fs-5"></i>CARGADOR
                  </label>
                  <input v-model="disCargador" required :disabled="distipDispositivo === '003'" type="text"
                    class="form-control" placeholder="-- CARGADOR --"
                    @input="disCargador = disCargador.replace(/^\s+/, '')"
                    @keydown.space="disCargador.length === 0 && $event.preventDefault()" />
                </div>

                <div class="col-md-6">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-chat-square-text text-primary fs-5"></i>COMENTARIO
                  </label>
                  <input v-model="disComentario" required type="text" class="form-control"
                    placeholder="-- COMENTARIO --" @input="disComentario = disComentario.replace(/^\s+/, '')" 
                    @keydown.space="disComentario.length === 0 && $event.preventDefault()" />
                </div>
              </div>

              <!-- ACCIONES -->
              <div class="modal-actions mt-4 d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-secondary px-4" @click="cerrarModal">Cancelar</button>
                <button :disabled="validarSimCard" type="submit" class="btn btn-primary px-4">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapGetters } from "vuex";

export default {
  name: "CopiasDispositivos",
  data() {
    return {
      busqueda: "",
      selectedRows: [],
      dispositivos: [],
      mostrarModal: false,
      modalModo: "agregar", //agregar o E
      modalForm: {},
      disTipo: "",
      disEmpresa: "",
      disProveedor: "",
      disModalidad: "",
      disGuia: "",
      disFactura: "",
      disFecCompra: "",
      disMontoSinIgv: 0,
      disMarca: "",
      disModelo: "",
      disProcesador: "",
      disMemoria: "",
      disDiscoDuro: "",
      disSerie: "",
      disCargador: "",
      disComentario: "",
      idUsuario: "",
      linEstado: [],
      currentPage: 1,
      itemsPerPage: 15,
      ModalidadArreglo: [],
      EstadoDis: [],
      Proveedores: [],
      EstadoDispo: [],
      loading: false,

      idDispositivo: "",
      editarDispo: {},
      distipDispositivo: "",
      disEstado: "005",
      validarSimCard: false,
      sortKey: "",
      sortOrder: "asc"
    };
  },

  computed: {
    ...mapGetters("users", ["DniEmpre"]),

    // 🔹 1. FILTRAR
    dispositivosFiltrados() {
      if (!Array.isArray(this.dispositivos)) return [];
      if (!this.busqueda) return this.dispositivos;

      const texto = this.busqueda.toLowerCase();

      return this.dispositivos.filter(d =>
        String(d.idDispositivo).toLowerCase().includes(texto) ||
        d.disModelo?.toLowerCase().includes(texto) ||
        d.disMarca?.toLowerCase().includes(texto) ||
        d.disSerie?.toLowerCase().includes(texto)
      );
    },

    // 🔹 2. ORDENAR (GLOBAL)
    dispositivosOrdenados() {
      let lista = [...this.dispositivosFiltrados];

      if (!this.sortKey) return lista;

      return lista.sort((a, b) => {
        let A = a[this.sortKey];
        let B = b[this.sortKey];

        // 👉 fechas
        if (this.sortKey === "disFecCompra") {
          A = new Date(A);
          B = new Date(B);
        }

        // 👉 números
        if (this.sortKey === "disMontoSinIgv") {
          A = Number(A);
          B = Number(B);
        }

        // 👉 texto / null
        A = A ?? "";
        B = B ?? "";

        if (A < B) return this.sortOrder === "asc" ? -1 : 1;
        if (A > B) return this.sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    },

    // 🔹 3. PAGINAR (DESPUÉS de ordenar)
    dispositivosPaginados() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.dispositivosOrdenados.slice(start, start + this.itemsPerPage);
    },

    totalPages() {
      return Math.ceil(this.dispositivosOrdenados.length / this.itemsPerPage);
    }
  },

  created() {
    // const tiempoTranscurrido = Date.now();
    // const hoy = new Date(tiempoTranscurrido);
    // this.disFecCompra = hoy.toISOString().slice(0, 10);

    this.dniTrabajador = localStorage.getItem("dniUsers");
    this.idUsuario = localStorage.getItem("userId");


    this.obtenerDispositivos()
    this.axios.get(`ParametroData/Parametro/7748`).then(r => {
      this.ModalidadArreglo = r.data
    })
    this.axios.get("ParametroData/Parametro/7716").then((r) => {
      this.linEstado = r.data
    })
    this.axios.get(`ParametroData/Parametro/7720`).then((r) => {
      this.EstadoDis = r.data
    })
    this.axios.get(`ParametroData/Parametro/7710`).then((r) => {
      this.Proveedores = r.data
    })
    this.axios.get(`ParametroData/Parametro/7724`).then((r) => {
      this.EstadoDispo = r.data
    })
  },
  methods: {
    ordenar(campo) {
      if (this.sortKey === campo) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = campo;
        this.sortOrder = "asc";
      }
    },

    validarSim() {

      const dispositivo = this.dispositivos.find(dispositivo => dispositivo.disSerie == this.disSerie);
      this.validarSimCard = dispositivo ? true : false;
      console.log(this.validarSimCard)

    },

    abrirModal(modo, informacion) {
      this.modalModo = modo;

      if (modo === "editar") {
        this.editarDispo = informacion
        //this.editarRotac.desLinEstado="001"

        console.log(this.editarDispo)
        this.idDispositivo = informacion.idDispositivo;

        this.disModelo = informacion.disModelo;
        this.disMarca = informacion.disMarca;
        this.disGuia = informacion.disGuia;
        this.disFactura = informacion.disFactura;
        this.disProcesador = informacion.disProcesador;
        this.disMemoria = informacion.disMemoria;
        this.disDiscoDuro = informacion.disDiscoDuro;
        this.disSerie = informacion.disSerie;
        this.disCargador = informacion.disCargador;
        this.disComentario = informacion.disComentario;
        this.disMontoSinIgv = informacion.disMontoSinIgv.toFixed(2);


        this.disEmpresa = informacion.idEmpresa;
        this.disModalidad = informacion.disModalidad;
        this.disProveedor = informacion.disProveedor;
        this.distipDispositivo = informacion.distipo;
        this.disEstado = informacion.disEstado;

        this.disFecCompra = this.convertirFechaParaInput(informacion.disFecCompra);

      } else {
        this.resetFormulario();
      }

      this.mostrarModal = true;
    },
    convertirFechaParaInput(fecha) {
      if (!fecha) return '';
      const partes = fecha.split('/');
      return `${partes[2]}-${partes[1]}-${partes[0]}`;
    },
    resetFormulario() {
      this.editarDispo = {};

      this.disGuia = "";
      this.disFactura = "";
      this.disMontoSinIgv = "";
      this.disProcesador = "";
      this.disMemoria = "";
      this.disDiscoDuro = "";
      this.disSerie = "";
      this.disCargador = "";
      this.disComentario = "";
      this.disFecCompra = "";
      this.disMarca = "";
      this.disModelo = "";



    },

    cerrarModal() {
      this.mostrarModal = false;
      this.validarSimCard = false
    },
    mandarTipDisp(event) {
      this.distipDispositivo = event.target.value;

      if (this.distipDispositivo === "003") {
        this.disMarca = "0";
        this.disModelo = "0";
        this.disProcesador = "0";
        this.disMemoria = "0";
        this.disDiscoDuro = "0";
        this.disCargador = "0";
      } else {
        // Otros dispositivos → limpiar
        this.disMarca = "";
        this.disModelo = "";
        this.disProcesador = "";
        this.disMemoria = "";
        this.disDiscoDuro = "";
        this.disCargador = "";
      }
    },
    mandarTipDispo(event) {
      this.disEstado = event.target.value;

    },
    EscogerProvedores(event) {
      this.disProveedor = event.target.value;
    },
    EscogerEmpresa(event) {
      this.disEmpresa = event.target.value;


      this.axios
        .get(`Ccosto/CentroxTrabajador?idEmpresa=${event.target.value}&dniUser=${this.dniTrabajador}`)
        .then((r) => {
          console.log(r.data);
          this.CentroCosto = r.data;
        });
    },

    Modalidad(event) {
      this.disModalidad = event.target.value;

    },

    async guardarModal() {
      const Guardar = {
        disTipo: this.distipDispositivo,
        disEmpresa: this.disEmpresa,
        disProveedor: this.disProveedor,
        disModalidad: this.disModalidad,
        disGuia: this.disGuia,
        disFactura: this.disFactura,
        disFecCompra: `${this.disFecCompra}` + "T00:00:00",
        disMontoSinIgv: this.disMontoSinIgv,
        disMarca: this.disMarca,
        disModelo: this.disModelo,
        disProcesador: this.disProcesador,
        disMemoria: this.disMemoria,
        disDiscoDuro: this.disDiscoDuro,
        disSerie: this.disSerie,
        disCargador: this.disCargador,
        disEstado: this.disEstado,
        disComentario: this.disComentario,
        idUsuario: this.idUsuario,
      };

      if (this.modalModo === "agregar") {
        this.axios.post("Tecnologia/RegistrarDispositivoTecnologico", Guardar).then(r => {
          console.log(r.data);
          if (r.data.success) {
            Swal.fire({
              title: "¡Registro exitoso!",
              text: "La información se ha guardado correctamente.",
              icon: "success"
            });

            this.obtenerDispositivos();
            this.cerrarModal();

          } else {
            Swal.fire({
              icon: "error",
              title: "Error al registrar",
              text: "No se Registro",
            });
          }
        });
      } else {
        Guardar.idDispositivo = this.idDispositivo
        this.axios.put("Tecnologia/ModificarDispositivo", Guardar).then(r => {
          console.log(r.data);

          if (r.data.success) {
            Swal.fire({
              title: "Operación exitosa",
              text: "Dispositivo editado correctamente.",
              icon: "success"
            });
            this.obtenerDispositivos();
            this.cerrarModal();
          } else {
            Swal.fire({
              icon: "error",
              title: "Error al registrar",
              text: "No se pudo Editar ",
            });
          }
        });

      }
    },

    eliminarSeleccionados() {
      this.dispositivos = this.dispositivos.filter(
        (d) => !this.selectedRows.includes(d)
      );
      this.selectedRows = [];
    },

    filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 900);
    },

    async obtenerDispositivos() {
      try {
        this.axios.get("Tecnologia/DispositivoTecnologico").then((r) => {
          this.dispositivos = r.data;
        });
      } catch (error) {
        console.error("Error al obtener movimientos:", error);
      }
    },
  },
};
</script>

<style scoped>
.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}


.input-group {
  max-width: 350px;
}

.row.mb-3 {
  margin-bottom: 1.0rem !important;
}



.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565C0;
}

.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.tamaño {
  font-size: 0.70rem;

  font-weight: 800;
  color: #002c5d;
}
</style>